import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Modal, message, Radio, Button, Spin } from 'antd';
import { trackDownloadEvent } from "./../../Utils/AnalyticsUtils"
import {
  downloadPricesList,
  setShowPricesListModal,
  getBrandsBySegments
} from '../../actions'
import SegmentsBrandsSelector from './SegmentsBrandsSelector';

const FORMAT_EXCEL = 'excel';
const FORMAT_PDF = 'pdf';

class DownloadPricesListModal extends Component {

  getInitialState = () => ({
    selectedItems: [],
    format: FORMAT_EXCEL,
  });

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  componentDidMount () {
    const { segmentos } = this.props;

    if (!segmentos) {
      this.props.getBrandsBySegments([]);
    }
  }

  handleDownload(format) {
    const { t, downloadPricesList } = this.props;
    const filter = this.state.selectedItems;

    // Check that exists at least one item
    const hasSelectedItems = Object.values(filter).some(array => array.length > 0);

    if (!hasSelectedItems) {
        message.warning(t('Select at least one segment or brand'));
        return;
    }

    trackDownloadEvent(format);
    downloadPricesList(filter, format);
}

  componentDidUpdate(prevProps) {
    if (prevProps.showPricesListModal && !this.props.showPricesListModal) {
      this.setState(this.getInitialState());
    }
  }

  handleModalClose = () => {
    this.props.setShowPricesListModal();
    this.setState(this.getInitialState());
  }

  handleSegmentCheckboxChange = (segment, checked) => {
    const newSelectedItems = { ...this.state.selectedItems };
    if (checked) {
      newSelectedItems[segment.id] = segment.brands.map(brand => brand.id);
    } else {
      delete newSelectedItems[segment.id];
    }
    this.setState({ selectedItems: newSelectedItems });
  }

  handleBrandCheckboxChange = (segmentId, brandId, checked) => {
    const newSelectedItems = { ...this.state.selectedItems };
    if (checked) {
      if (!newSelectedItems[segmentId]) {
        newSelectedItems[segmentId] = [];
      }
      newSelectedItems[segmentId].push(brandId);
    } else {
      newSelectedItems[segmentId] = newSelectedItems[segmentId].filter(id => id !== brandId);
      if (newSelectedItems[segmentId].length === 0) {
        delete newSelectedItems[segmentId];
      }
    }
    this.setState({ selectedItems: newSelectedItems });
  }

  render() {
    const { t, isModalOpen, segmentos, downloadingPricesList } = this.props;
    const { format, selectedItems } = this.state;

    return (
      <Modal
        title={t('Price list')}
        visible={isModalOpen}
        onCancel={() => this.handleModalClose()}
        footer={
          <div className="pricesList-modal-footer">
            <Radio.Group
              key="format-selector"
              value={format}
              onChange={(e) => this.setState({ format: e.target.value })}
              buttonStyle="solid"
            >
              <Radio.Button value={FORMAT_EXCEL}>{t('Excel')}</Radio.Button>
              <Radio.Button value={FORMAT_PDF}>{t('PDF')}</Radio.Button>
            </Radio.Group>
            <div className="pricesList-modal-button-group">
              <Button key="cancel" onClick={() => this.handleModalClose()} type="secondary">{t('Cancel')} </Button>
              <Button
                  data-testid="download-button"
                  key="download"
                  onClick={() => this.handleDownload(format)}
                  type="primary"
                  disabled={downloadingPricesList}
              >
                  {t('download')}
              </Button>
            </div>
          </div>
        }
      >
        {downloadingPricesList || !segmentos ? <Spin size="large" className="spin-container"/> : (
          <SegmentsBrandsSelector
            segmentos={segmentos}
            selectedItems={selectedItems}
            onSegmentChange={this.handleSegmentCheckboxChange}
            onBrandChange={this.handleBrandCheckboxChange}
          />
        )}
      </Modal>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  downloadPricesList: (filter, format) => {
    dispatch(downloadPricesList(filter, format));
  },
  setShowPricesListModal: () => {
    dispatch(setShowPricesListModal());
  },
  getBrandsBySegments: () => {
    dispatch(getBrandsBySegments());
  },
});

const mapStateToProps = ({ catalog }) => {
  const { selectedSegments, downloadingPricesList, showPricesListModal } = catalog;
  const segmentos = selectedSegments && selectedSegments.segmentos ? selectedSegments.segmentos : null;

  return {
    segmentos,
    downloadingPricesList,
    showPricesListModal
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DownloadPricesListModal));

